import React from "react";
import "./index.scss";

import png011 from "./images/01-1.png";
import logo from "./images/logo.svg";
import img02 from "./images/02.png";
import img03 from "./images/03.png";
import img04 from "./images/04.png";

import regulations from "../../../assets/files/Regulamin-Taniej-z-mBankiem.pdf"

import { Helmet } from "react-helmet";

const LandingPageTaniejZmBank = () => {
  return (
    <div className="lp-taniej-z-mbank">
      <Helmet>
        <title>Taniej z mBankiem</title>
        <meta name="description" content="" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <div className="wrapper">
        <div className="x-content-box-1">
          <div className="container">
            <div className="wrapper-2">
              <div className="description">
                <div className="header-logo">
                  <a href="https://mauto.pl/" target="_blank" rel="noreferrer">
                    <img src={logo} alt="" />
                  </a>
                </div>
                <div className="txt-box">
                  <h1>korzystny zwrot akcji z&nbsp;mBankiem</h1>
                  <div className="txt">
                    <span>spłacaj leasing</span> z konta firmowego w&nbsp;mBanku i <span>zyskaj 2000 zł rabatu</span>
                  </div>
                </div>
                <div className="button-box">
                  <a
                    className="btn-1"
                    href="https://form.mbank.pl/app/f_rachunki/index.htm?promocja=pk24kd1&option=leasing&kampania=banner"
                    target="_blank"
                    rel="noreferrer"
                    title="kliknij, załóż konto"
                  >
                    załóż konto
                  </a>
                  <a
                    className="btn-1 btn-1-1"
                    href="https://mauto.pl/lista-pojazdow"
                    target="_blank"
                    rel="noreferrer"
                    title="kliknij, wybierz auto"
                  >
                    wybierz auto
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="banner-image-rwd">
          <img src={png011} alt="banner" />
        </div>

        <div className="x-content-box-2 x-content-box-2-1 pt1">
          <div className="container">
            <div className="wrapper-1">
              <div className="title">
                <h2>
                  teraz z rachunkiem firmowym w mBanku
                  <br /> zyskujesz jeszcze więcej!
                </h2>
              </div>

              <div className="txt-1">
                spłacaj raty leasingu z rachunku firmowego w mBanku i odbierz <strong>2000 zł rabatu</strong> na 6.
                ratę!
              </div>

              <div className="x-content-box-2-1">
                <div className="description font20">
                  <h3>wystarczy, że spełnisz dwa proste warunki:</h3>
                  <div className="x-boxes-1">
                    <div className="x-box-1">
                      <div className="number">1</div>
                      <div className="txt">
                        spłacisz co najmniej <strong>dwie z trzech pierwszych rat leasingowych</strong>
                        z&nbsp;rachunku firmowego w mBanku
                      </div>
                    </div>
                    <div className="x-box-1">
                      <div className="number">2</div>
                      <div className="txt">
                        i każda Twoja rata zostanie uregulowana{" "}
                        <strong>w terminie i&nbsp;w&nbsp;pełnej wysokości</strong>
                      </div>
                    </div>
                  </div>
                  <div className="txt-2">
                    <p>
                      Promocja dotyczy leasingu pojazdów o wartości co najmniej 100 000 zł netto. Jeśli nie masz jeszcze
                      rachunku firmowego w&nbsp;mBanku, możesz go założyć szybko i wygodnie{" "}
                      <a
                        href="https://form.mbank.pl/app/f_rachunki/index.htm?promocja=pk24kd1&option=leasing&kampania=www"
                        target="_blank"
                        rel="noreferrer"
                        className="link-red"
                      >
                        tutaj
                      </a>
                      . Szczegóły promocji w{" "}
                      <a href={regulations} target="_blank" rel="noreferrer">
                        regulaminie
                      </a>
                      .
                    </p>
                    <p>
                      Jeśli nie wybrałeś jeszcze auta, możesz je wybrać z naszej oferty mAuto – kliknij{" "}
                      <a href="https://mauto.pl/lista-pojazdow" target="_blank" rel="noreferrer" className="link-red">
                        tutaj
                      </a>
                      .
                    </p>
                  </div>
                  <div className="button-box">
                    <a
                      className="btn-1 btn-1-small"
                      href="https://mauto.pl/formularz-kontaktowy"
                      target="_blank"
                      rel="noreferrer"
                      title="kliknij, zapytaj o ofertę"
                    >
                      zapytaj o ofertę
                    </a>
                    <a
                      className="btn-1 btn-1-2 btn-1-small"
                      href="https://form.mbank.pl/app/f_rachunki/index.htm?promocja=pk24kd1&option=leasing&kampania=www"
                      target="_blank"
                      rel="noreferrer"
                      title="kliknij, załóż konto"
                    >
                      załóż konto
                    </a>
                  </div>
                </div>
                <figure>
                  <img src={img02} alt="" />
                </figure>
              </div>

              <div className="line-1 mt1 mb1"></div>
            </div>
          </div>
        </div>

        <div className="x-content-box-3 pb1 pb2">
          <div className="container">
            <div className="title">
              <h2>dlaczego warto?</h2>
            </div>

            <div className="x-content-box-3-1">
              <div className="image">
                <figure>
                  <img src={img03} alt="" />
                </figure>
              </div>
              <div className="x-boxes-2">
                <div className="x-box-2 x-box-2-1">
                  <h3>oszczędność i prostota dla&nbsp;Twojej firmy</h3>
                  <ul>
                    <li>
                      <strong>2000 zł rabatu</strong> na 6. ratę leasingu
                    </li>
                    <li>
                      finansowanie i rachunek w jednym banku – <strong>mniej formalności, więcej&nbsp;kontroli</strong>
                    </li>
                  </ul>
                </div>
                <div className="x-box-2 x-box-2-2">
                  <h3>konto firmowe za 0 zł</h3>
                  <ul>
                    <li>
                      <strong>0 zł</strong> za prowadzenie rachunku firmowego
                    </li>
                    <li>
                      zarządzaj wygodnie finansami
                      <strong>w&nbsp;jednym miejscu</strong>
                    </li>
                  </ul>
                </div>
                <div className="x-box-2 x-box-2-3">
                  <h3>szybka procedura</h3>
                  <ul>
                    <li>
                      wszystko możesz załatwić zdalnie
                      <span style={{ whiteSpace: "nowrap" }}>– wybierasz</span> auto, podpisujesz umowę, korzystasz z
                      promocji
                    </li>
                  </ul>
                </div>
                <div className="x-box-2 x-box-2-4">
                  <h3>wsparcie ekspertów</h3>
                  <ul>
                    <li>nasi doradcy są do Twojej dyspozycji na każdym etapie</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="button-box-1">
            <a
              className="btn-1 btn-1-small"
              href="https://mauto.pl/formularz-kontaktowy"
              target="_blank"
              rel="noreferrer"
              title="kliknij, zapytaj o ofertę"
            >
              zapytaj o ofertę
            </a>
          </div>
        </div>

        <div className="x-content-box-2 x-content-box-2-2 pt1 pt2">
          <div className="container">
            <div className="wrapper-1">
              <div className="title title-line">
                <h2>jak skorzystać z&nbsp;promocji?</h2>
              </div>

              <div className="x-content-box-2-1">
                <div className="description font20">
                  <div className="x-boxes-1 x-boxes-2-1">
                    <div className="x-box-1">
                      <div className="number">1</div>
                      <div className="txt">
                        <a
                          href="https://form.mbank.pl/app/f_rachunki/index.htm?promocja=pk24kd1&option=leasing&kampania=www"
                          target="_blank"
                          rel="noreferrer"
                        >
                          załóż rachunek
                        </a>{" "}
                        firmowy w mBanku
                      </div>
                    </div>
                    <div className="x-box-1">
                      <div className="number">2</div>
                      <div className="txt">
                        wybierz auto i podpisz umowę leasingu lub najmu <br />
                        na wybrane auto albo auto z oferty{" "}
                        <a href="https://mauto.pl/lista-pojazdow" target="_blank" rel="noreferrer">
                          mAuto
                        </a>
                      </div>
                    </div>
                    <div className="x-box-1">
                      <div className="number">3</div>
                      <div className="txt">
                        <strong>spłać 2 z 3 pierwszych rat</strong> z konta firmowego w&nbsp;mBanku
                      </div>
                    </div>
                    <div className="x-box-1">
                      <div className="number">4</div>
                      <div className="txt">
                        Twoja 6. rata zostanie automatycznie <strong>pomniejszona o 2000 zł rabatu!</strong>
                      </div>
                    </div>
                  </div>
                </div>
                <figure>
                  <img src={img04} alt="" />
                </figure>
              </div>

              <div className="txt-3 mb1 mt1">Nie zwlekaj - promocja trwa tylko do 31 października 2025 r.</div>
            </div>
          </div>
        </div>

        <div className="x-content-box-4 pt1 pb1">
          <div className="container">
            <div className="txt-1 mb1">załóż konto firmowe w mBanku, skorzystaj z leasingu i zyskaj więcej!</div>

            <div className="x-boxes-3">
              <div className="x-box-3">
                <figure>
                  <img src="./images/icon01.svg" alt="" />
                </figure>
                <div className="button-box">
                  <a
                    target="_blank"
                    href="https://form.mbank.pl/app/f_rachunki/index.htm?promocja=pk24kd1&option=leasing&kampania=www"
                    className="btn-1 btn-1-small btn-1-3"
                    rel="noreferrer"
                    title="kliknij, załóż konto firmowe"
                  >
                    załóż konto firmowe
                  </a>
                </div>
              </div>
              <div className="x-box-3">
                <figure>
                  <img src="./images/icon02.svg" alt="" />
                </figure>
                <div className="button-box">
                  <a
                    href="https://mauto.pl/formularz-kontaktowy"
                    className="btn-1 btn-1-small btn-1-3"
                    target="_blank"
                    rel="noreferrer"
                    title="kliknij, zapytaj o ofertę"
                  >
                    zapytaj o ofertę
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer className="footer-box pt1 pb1">
         <div className="container">
            <a href={regulations} target="_blank" rel="noreferrer"><strong>Regulamin</strong></a><br /><br />
            Informacja jest informacją handlową i nie stanowi oferty w rozumieniu przepisów Kodeksu cywilnego. Ma charakter jedynie poglądowy i pomocniczy 
            w&nbsp;przygotowaniu właściwej umowy. Umowa wymaga formy pisemnej pod rygorem nieważności i może być zawarta nie wcześniej niż po podjęciu przez mLeasing sp. z o.o. pozytywnej decyzji o finansowaniu. mAuto jest serwisem internetowym należącym do mLeasing sp.&nbsp;z&nbsp;o.o., stroną umowy będzie mLeasing sp.&nbsp;z&nbsp;o.o.
         </div>
      </footer>
      </div>
    </div>
  );
};

export default LandingPageTaniejZmBank;
